<template>
  <el-dialog
    title="未完成发货说明"
    :visible.sync="visible"
    width="800px"
    top="5vh"
    :close-on-click-modal="false"
    @opened="onOpened"
    class="dialog-Individuation"
  >
    <el-form
      :model="formObj"
      ref="formObj"
      label-suffix=":"
      label-width="140px"
      :rules="rules"
    >
      <el-divider content-position="left" class="line"
        >未完成发货说明</el-divider
      >
      <el-form-item label="情况说明" prop="remark">
        <el-input
          type="textarea"
          v-model="formObj.remark"
          maxlength="400"
          show-word-limit
        ></el-input>
      </el-form-item>

      <onUploadShipping
        @fileDataSingle="onReserveFiles"
        :fileList="formObj.remarkFiles"
        labelWidth="140px"
        labelName="说明附件"
      ></onUploadShipping>

      <el-form-item prop="clearanceEndTime" label="预期清运完成日期">
        <el-date-picker
          size="small"
          v-model="formObj.clearanceEndTime"
          type="date"
          placeholder="选择日期时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-divider content-position="left" class="line">经办人信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="contName">
            <el-input v-model="formObj.contName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机" prop="contMobile">
            <el-input v-model="formObj.contMobile"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="电话">
            <el-input v-model="formObj.contPhone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="contEmail">
            <el-input v-model="formObj.contEmail"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="onSubmit(1)">提交</el-button>
      <el-button type="primary" @click="onSubmit(0)">保存</el-button>
      <el-button type="primary" @click="onCancel">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ShippingDialog',
  props: {
    show: Boolean,
    selectData: Object
  },
  components: {},
  data() {
    return {
      loading: false,
      active: 0,
      formObj: {
        remarkFiles: [],
        remark: '',
        clearanceEndTime: '',
        contName: '',
        contMobile: '',
        contPhone: '',
        contEmail: ''
      },
      rules: {
        remark: [{ required: true, message: ' ', trigger: 'blur' }],
        clearanceEndTime: [{ required: true, message: ' ', trigger: 'change' }],
        contMobile: [
          {
            required: true,
            message: '请填写正确的手机号',
            pattern: /^1[0-9]{10}$/,
            trigger: 'blur'
          }
        ],
        contName: [{ required: true, message: ' ', trigger: 'blur' }],
        contEmail: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(v) {
        this.$emit('update:show', v)
      }
    }
  },

  methods: {
    onOpened() {
      if (this.selectData.clearanceRecordId) {
        this.clearanceRecordCheck()
      }
    },
    async clearanceRecordCheck() {
      let params = {
        id: this.selectData.clearanceRecordId
      }
      let data = await this.$api.materialdisposal.clearanceRecordCheck(params)
      this.formObj = data
      if (this.formObj.remarkFiles && this.formObj.remarkFiles.length != 0) {
        this.formObj.remarkFiles.map(item => {
          item.name = item.fileName
        })
      }
    },
    onRegister() {},
    onIncomplete() {
      this.$router.push({ name: 'IncompleteShipping' })
    },
    onReserveFiles(val) {
      this.formObj.remarkFiles = val
    },
    onSubmit(type) {
      console.log(type)
      this.$refs.formObj.validate(valid => {
        if (valid) {
          this.clearanceRecordSave(type)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async clearanceRecordSave(type) {
      let params = {
        ...this.formObj,
        statusCode: type
      }
      let data
      if (this.selectData.clearanceRecordId) {
        params.id = this.selectData.clearanceRecordId
        data = await this.$api.materialdisposal.clearanceRecordUpdate(params)
      } else {
        params.orderId = this.selectData.orderId
        data = await this.$api.materialdisposal.clearanceRecordSave(params)
      }
      if (data) {
        if (type == 1) {
          this.$message.success('提交成功')
        } else {
          this.$message.success('保存成功')
        }
        this.onCancel()
        this.$emit('success', true)
      }
    },
    clearanceRecordUpdate() {},
    onCancel() {
      this.$emit('update:show', false)
      this.formObj = {
        remarkFiles: [],
        remark: '',
        clearanceEndTime: '',
        contName: '',
        contMobile: '',
        contPhone: '',
        contEmail: ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.line {
  margin: 40px 0;
}
</style>
